import { InlineTextInput } from "@nova/component-inline-text-input"
import { InspectorPanelKeyValueDropdown } from "../InspectorPanelKeyValueDropdown"
import { decodeNumberToColor } from "@nova/serializer/src/client/util"
import { ColorPalette } from "./TODO-put-in-package/ColorPalette"
import { numberIconColorSwatches } from "./InspectorPanelIconLayer"
import * as Icons from "@nova/component-icons"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import {
    selectIconNumberStartAt,
    selectIconTemplate,
    setIconNumberStartAt,
    updateIconTemplate,
} from "plugins/Toolbox/tool-registry"
import { useEffect, useState } from "react"
import { thicknesses } from "../lines/constants"
import { LineWidth, lineWidthNameByLineWidth } from "@nova/constants"
import { LineThicknessPicker } from "../lines/LineThicknessPicker"
import { updateIcon } from "features/pubsub/entityActions/cubes/icon"
import { selectIconById } from "features/entity-caching/icons/selectors"

export const InspectorPanelIconNumberMenu = ({
    id,
    color,
    setColor,
    width,
    setWidth,
    outline,
    setOutline,
}: {
    id?: string
    color: number
    setColor: (color: number) => void
    width: LineWidth
    setWidth: (width: LineWidth) => void
    outline: number
    setOutline: (outline: number) => void
}) => {
    const icon = useAppSelector(selectIconById(id || ""))
    // checking both conditions for type narrowing
    const isMock = !id || !icon
    const dispatch = useAppDispatch()
    const iconTemplate = useAppSelector(selectIconTemplate)
    useEffect(() => {
        const num = isMock ? iconTemplate.url.split("numbers/")[1] : icon.url.split("numbers/")[1]
        if (num) setNumberStartAt(num)
    }, [iconTemplate, isMock, icon])
    const numberStartAtFromTemplate = useAppSelector(selectIconNumberStartAt())
    const [numberStartAt, setNumberStartAt] = useState(
        isMock ? numberStartAtFromTemplate.toString() : icon.url.split("numbers/")[1] || "1"
    )
    const [dropdownId, setDropdownId] = useState<string | undefined>()
    return (
        <>
            <div className={"flex-none h-8 relative"}>
                {!isMock ? (
                    <div className={"flex items-center w-full text-gray-0 h-8"}>
                        <h5 className="w-24 select-none flex-none">Number</h5>

                        <InlineTextInput
                            name="number"
                            className="ml-3"
                            inputClassName="placeholder:text-gray-300 text-[14px] !border-none !outline-none focus:!outline-none focus:!ring-0 focus:!border-transparent !py-0"
                            autoComplete="off"
                            handleChange={(val) => {
                                if (!val) return setNumberStartAt("")
                                const num = Number(val)
                                if (val.toString() !== num.toFixed(0) || num > 99 || num < 1) return
                                dispatch(
                                    updateIcon({
                                        id,
                                        updates: { url: `numbers/${num}` },
                                    })
                                )
                                setNumberStartAt(val)
                            }}
                            value={numberStartAt}
                        />
                    </div>
                ) : (
                    <div className={"flex items-center w-full text-gray-0 h-8"}>
                        <h5 className="w-24 select-none flex-none">Start at</h5>

                        <InlineTextInput
                            name="number"
                            className="ml-3"
                            inputClassName="placeholder:text-gray-300 text-[14px] !border-none !outline-none focus:!outline-none focus:!ring-0 focus:!border-transparent !py-0"
                            autoComplete="off"
                            handleChange={(val) => {
                                if (!val) return setNumberStartAt("")
                                const num = Number(val)
                                if (val.toString() !== num.toFixed(0)) return
                                if (num > 99 || num < 1) return
                                setNumberStartAt(val)
                                dispatch(setIconNumberStartAt(num))
                                dispatch(updateIconTemplate({ url: "numbers/" + val }))
                            }}
                            value={numberStartAt}
                        />
                    </div>
                )}
            </div>

            <InspectorPanelKeyValueDropdown
                id="color"
                isOpen={dropdownId === "color"}
                setOpenDropdownId={setDropdownId}
                keyTitle="Color"
                Icon={Icons.BucketColor}
                iconClasses="text-gray-0"
                iconAccentColor={decodeNumberToColor(color)}
            >
                <ColorPalette
                    swatches={numberIconColorSwatches}
                    selectedColor={color}
                    setSelectedColor={setColor}
                    setOpenDropdownId={setDropdownId}
                />
            </InspectorPanelKeyValueDropdown>
            <hr className="my-2.5 border-gray-700" />
            <InspectorPanelKeyValueDropdown
                id="outline"
                isOpen={dropdownId === "outline"}
                setOpenDropdownId={setDropdownId}
                keyTitle="Outline Color"
                Icon={Icons.BucketColor}
                iconClasses="text-gray-0"
                iconAccentColor={decodeNumberToColor(outline)}
            >
                <ColorPalette
                    swatches={numberIconColorSwatches}
                    selectedColor={outline}
                    setSelectedColor={setOutline}
                    setOpenDropdownId={setDropdownId}
                />
            </InspectorPanelKeyValueDropdown>
            <InspectorPanelKeyValueDropdown
                id="width"
                isOpen={dropdownId === "width"}
                setOpenDropdownId={setDropdownId}
                keyTitle="Outline Width"
                Icon={thicknesses[width]}
                dropdownTitle={lineWidthNameByLineWidth[width]}
                iconClasses="text-gray-0"
            >
                <LineThicknessPicker
                    hasNoneOption
                    selectedThickness={width}
                    setSelectedThickness={setWidth}
                    setOpenDropdownId={setDropdownId}
                />
            </InspectorPanelKeyValueDropdown>
        </>
    )
}
